export const exists = (selector) => {
    return document.querySelectorAll(selector).length > 0;
};